import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@mui/material';

import { GridViewOutlined } from '@mui/icons-material';

import {
  bodyCellSx,
  headCellSx,
  paginationSx,
  patientNameCellSx,
  recapButtonSx,
  recapIconSx,
  tableBodyRowSx,
  tableHeadRowSx,
  tablePaperSx,
  tableSx
} from '../../../Default/components/Home/components/styles';

const PatientTable = ({
  count,
  onPageChange,
  onRecapOpen,
  onRowsPerPageChange,
  page,
  rows,
  rowsPerPage
}) => {
  return (
        <Paper
      sx={{
        ...tablePaperSx,
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden'
      }}>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          position: 'relative',
          overflow: 'hidden'
        }}>
        <TableContainer
          sx={{
            height: '100%',
            overflowY: 'auto',
            overflowX: 'hidden',

            '&::-webkit-scrollbar': {
              width: 5
            },

            '&::-webkit-scrollbar-track': {
              backgroundColor: 'transparent'
            },

            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#CFCFCF',
              borderRadius: 8
            },

            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#B5B5B5'
            },

            scrollbarWidth: 'thin',
            scrollbarColor: '#CFCFCF transparent'
          }}>
          <Table stickyHeader sx={tableSx}>
            <TableHead>
              <TableRow sx={tableHeadRowSx}>
                <TableCell sx={headCellSx}>PATIENT NAME</TableCell>

                <TableCell sx={headCellSx}>DATE OF BIRTH</TableCell>

                <TableCell sx={headCellSx}>SEX</TableCell>

                <TableCell sx={headCellSx}>LAST VISIT</TableCell>

                <TableCell align="center" sx={headCellSx}>
                  RECAP
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map(row => (
                <TableRow key={row.id} sx={tableBodyRowSx}>
                  <TableCell sx={patientNameCellSx}>{row.pname}</TableCell>

                  <TableCell sx={bodyCellSx}>{row.dob}</TableCell>

                  <TableCell sx={bodyCellSx}>{row.sex}</TableCell>

                  <TableCell sx={bodyCellSx}>{row.lastVisit}</TableCell>

                  <TableCell align="center" sx={bodyCellSx}>
                    <IconButton
                      aria-label={`View recap for ${row.pname}`}
                      size="small"
                      sx={recapButtonSx}
                      onClick={event => onRecapOpen(event, row)}>
                      <GridViewOutlined sx={recapIconSx} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {rows.length === 0 && (
                <TableRow>
                  <TableCell align="center" colSpan={5} sx={bodyCellSx}>
                    No patients found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <TablePagination
        component="div"
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[25, 50, 75, 100]}
        sx={{
          ...paginationSx,
          flexShrink: 0
        }}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </Paper>
  );
};

PatientTable.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRecapOpen: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      dob: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      lastVisit: PropTypes.string.isRequired,
      pname: PropTypes.string.isRequired,
      sex: PropTypes.string.isRequired
    })
  ).isRequired,
  rowsPerPage: PropTypes.number.isRequired
};

export default PatientTable;
